import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { DevelopUtil } from '../../utils/develop.utils';

@Injectable()
export class InformationHttpService {

  public static INFORMATION_URL = DevelopUtil.url('information');

  private headers: Headers;
  private requestOptions: RequestOptions;

  constructor(private http: Http) {
    this.headers = new Headers();
    this.requestOptions = new RequestOptions({headers: this.headers});
  }

  getInfo(urlSearchParams: URLSearchParams): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    return this.http.get(InformationHttpService.INFORMATION_URL, this.requestOptions);
  }

  setRead(urlSearchParams: URLSearchParams, id: String): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    return this.http.get(InformationHttpService.INFORMATION_URL + '/set/' + id, this.requestOptions);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/information/information.http.service.ts